import tw, { styled } from 'twin.macro';

export const CheckboxContainer = styled.div`
  ${tw`flex items-center absolute w-full top-2 left-2`}
  ${({ isList }) => isList && `position: static;`}
  
  user-select: none;
  height: 30px;
  width: 30px;
  &:hover {
    cursor: pointer;
  }
`;

export const Label = styled.label`
  ${tw`font-normal text-base pl-4 flex items-center relative w-full`}
  font-family: 'Circular Std' !important;
  color: #4f4f4f;
`;

export const Checked = styled.input`
  opacity: 0;
  height: 0;
  width: 0;
  &:hover ~ span:before {
    display: block;
  }
  &:checked ~ span {
    border-width: 1px;
    background: linear-gradient(270deg, #1a8caf -18.55%, #00afc4 60.48%);
  }
  &:checked ~ span:after {
    display: block;
  }
  &:checked:hover ~ span:after {
    border-color: #fff;
  }
  &:checked:disabled ~ span {
    background: #e5e5e5 !important;
    border-color: #ccc;
    cursor: not-allowed;
  }
  &:checked:disabled ~ span:after {
    border-color: #ccc;
  }
  &:not(:checked):disabled ~ span {
    background: #e5e5e5 !important;
    border: none;
    cursor: not-allowed;
  }
`;

export const Checkedbox = styled.span`
  ${tw`absolute left-0 bg-white cursor-pointer`}
  border: 0.6px solid #4aaec5;
  width: 18px;
  height: 18px;
  padding: 5px;
  display: inline-block;
  border-radius: 2px;

  &:after {
    content: '';
    position: absolute;
    display: none;
    left: 6px;
    top: 0.5px;
    width: 7px;
    height: 15px;
    border: solid #fff;
    border-width: 0 1.5px 1.5px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  &:before {
    content: '';
    position: absolute;
    display: none;
    left: -5px;
    top: -5px;
    width: 150%;
    height: 150%;
    border-radius: 50%;
    background-color: rgba(0, 141, 150, 0.07);
  }
`;

export const CategoriesWrapper = styled.div`
  ${tw`flex gap-8 bg-white p-4 w-full flex-wrap`};
  box-shadow: 0px 4px 25px rgba(231, 228, 228, 0.3);
`;

export const Category = styled.button`
  font-family: var(--formFontType, Circular Std) !important;
  font-size: var(--formFontSize, 12px);
  background: white;
  font-weight: 400;
  cursor: pointer;
  color: #a4a3a3;
  border: none;
  outline: 0;

  &.active {
    color: #28879d;
  }
`;
